<template>
  <div class="logo">
<!--    <img src="">-->
<!--    <div style="background: pink"></div>-->
    <img src="../assets/imgs/login-logo2@2x.png" style="width: 100%;height: 100%">
  </div>
</template>

<script>
  export default {
    name: "C-Logo"
  }
</script>

<style scoped>
.logo{
  /*background: pink;*/
  /*z-index: 998;*/
  width: 89px;
  height: 72px;
  position: fixed;
  left: 38%;
  bottom: 70px;
}
</style>